<template>
    <div class="mt-2" style="width: 100%;">
        <div style="justify-content: space-between;" class="flex">
            <div class="flex">
                <span class="font-bold">Totales ({{ arregloComunicaciones.length }})</span>
                <vx-tooltip style="display: inline-block;" text="Actualizar bandeja" position="top" color="dark">
                   <span @click="getComunicados()"><i class="fa-solid fa-rotate ml-2 cursor-pointer"></i></span> 
                </vx-tooltip>
            </div>
        </div>
        <div class="scroll mt-5 flex">
            <vs-table max-items="10" search pagination :data="arregloComunicaciones" style="width: 100%;">
                <template slot="thead">
                </template>
                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <td colspan="1"><i class="fa-regular fa-envelope"></i><span class="ml-4">{{ tr.emisor }}</span></td>
                        <td colspan="5" @click="openComunicado(tr)">
                            <p v-if="tr.tipo_comunicacion == 1">{{ tr.cursoReceptor }} - <b>{{ tr.tipoC }}</b></p>
                            <p v-if="tr.tipo_comunicacion == 2">{{ tr.usuario_receptor }} - <b>{{ tr.tipoC }}</b></p>
                            <p v-if="tr.tipo_comunicacion == 3">{{ tr.usuario_receptor }} - <b>{{ tr.tipoC }}</b></p>
                            <vs-divider></vs-divider>
                            <p v-html="tr.mensaje.substring(0,80)+'...'"></p>
                        </td>
                        <td colspan="1">
                            <div class="flex" style="flex-direction: column;">
                                <p v-if="tr.updated_at">{{ elapsedTime(tr.updated_at) }}</p>
                                <p v-else>{{ elapsedTime(tr.created_at) }}</p>
                                <p v-if="tr.contador > 0" class="text-center"><i class="fa-solid fa-paperclip"></i></p>
                            </div>
                        </td>
                    </vs-tr>
                </template>
            </vs-table> 
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
export default{
    data(){
        return{
        }
    },
    props:{
        institucion_General:{
           type:Object,
           default:()=>{}
        },
        arregloComunicaciones:{
            type:Array,
            default:()=>{}
        },
        totalTable:{
            type:Number,
            default:0
        },
    },
    mounted(){
    },
    methods:{
        getComunicados(){
            let me = this
            me.$emit('changeComunicados',true)
        },
        openComunicado(tr){
            let me = this;
            let datos = {
                comunicado: tr
            }
            me.$emit('changeOpen',datos)
        },
        elapsedTime(startTime) {
            const x = new Date(startTime)
            const now = new Date()
            let timeDiff = now - x
            timeDiff /= 1000
            const seconds = Math.round(timeDiff)
            timeDiff = Math.floor(timeDiff / 60)
            const minutes = Math.round(timeDiff % 60)
            timeDiff = Math.floor(timeDiff / 60)
            const hours = Math.round(timeDiff % 24)
            timeDiff = Math.floor(timeDiff / 24)
            const days = Math.round(timeDiff % 365)
            timeDiff = Math.floor(timeDiff / 365)
            const years = timeDiff
            if (years > 0) {
                return `${years + (years > 1 ? ' Años ' : ' Año ')}`
            } else if (days > 0) {
                return `Hace ${days + (days > 1 ? ' Días ' : ' Día ')}`
            } else if (hours > 0) {
                return `Hace ${hours + (hours > 1 ? ' Horas ' : ' Hora ')}`
            } else if (minutes > 0) {
                return `Hace ${minutes + (minutes > 1 ? ' Minutos ' : ' Minuto ')}`
            } else if (seconds > 0) {
                return 'Hace '+ seconds + (seconds > 1 ? ' segundos' : 'justo ahora')
            }
            return ' Justo Ahora '
        },
    }
}
</script>
<style scoped>
    *{
        font-size: 12px;
    }
    div.scroll {
        margin:4px, 4px;
        padding:4px;
        width: 100%;
        height: 80%;
        overflow-x: hidden;
        overflow-y: auto;
        text-align:justify;
    }
    .letra{
        font-size: 12px;
    }
    table{
        background-color: white;
        text-align: left;
        border-collapse: collapse;
        width: 100%;
        font-size: 11px;
    }
    th, td{
        padding: 20px;
        cursor: pointer;
        transition: 0.5 ease all;
    }
    thead{
        background-color: #246355;
        border-bottom: solid 5px #0F362D;
        color: white;
    }
    tr:nth-child(even){
        background-color: #f2f2f2;
    }
    tr,td{
        transition: 0.2s ease-in;
    }
    tr:hover td{
        opacity: 0.6;
        background-color: rgb(39, 30, 30);
        color: white;
    }
    .paginate{
        transition: 2s ease;
    }
    .paginate:hover{
        color:#3EA0EA;
        box-shadow: 1px 4px 4px #ccc;
    }
</style>